'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 0;\n\tbackground: ', ';\n\twidth: 60px;\n\theight: 60px;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\toutline: none;\n\tg {\n\t\tfill: ', ';\n\t}\n\t', '\n\t&:disabled {\n\t\tpointer-events: none;\n\t\tbackground: ', ';\n\t\tg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 0;\n\tbackground: ', ';\n\twidth: 60px;\n\theight: 60px;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\toutline: none;\n\tg {\n\t\tfill: ', ';\n\t}\n\t', '\n\t&:disabled {\n\t\tpointer-events: none;\n\t\tbackground: ', ';\n\t\tg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../../constants/colors');

var _opacity = require('../../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _plus = require('../../icons/plus');

var _plus2 = _interopRequireDefault(_plus);

var _getColor = require('../../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AddButtonComponent = _styledComponents2.default.button(_templateObject, function (_ref) {
	var color = _ref.color;
	return color ? color : _colors.Colors.Primary;
}, (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.Full), function (_ref2) {
	var isDesktop = _ref2.isDesktop;
	return isDesktop && '\n\t&:hover {\n\t\tbackground: ' + _colors.Colors.Secondary + ';\n\t}\n\t';
}, (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.Lighter), (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.Full));

var AddButton = function (_Component) {
	_inherits(AddButton, _Component);

	function AddButton() {
		_classCallCheck(this, AddButton);

		return _possibleConstructorReturn(this, (AddButton.__proto__ || Object.getPrototypeOf(AddButton)).apply(this, arguments));
	}

	_createClass(AddButton, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				AddButtonComponent,
				{ className: this.props.className, disabled: this.props.disabled, color: this.props.color, onClick: this.props.clickEvent, isDesktop: this.context.screen.isDesktop },
				_react2.default.createElement(_plus2.default, { size: this.props.plusSignSize, primary: this.props.plusColor })
			);
		}
	}]);

	return AddButton;
}(_react.Component);

AddButton.contextTypes = {
	screen: _propTypes2.default.object
};

exports.default = AddButton;